module.exports = __webpack_public_path__ + "static/media/mobile_card_badge_shape.1eb8f52f.svg";